import React, { useEffect, useState } from 'react';
import '../../styles/contests.css';
import { services } from '../../apis';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useSelector, useDispatch } from 'react-redux';
import { Routes, Route, useNavigate } from 'react-router-dom';
import leaderboard from './leaderboard.svg';
import leaderboardGraph from './leaderboardGraph.svg';
import Loader from '../../components/Loader';
import {
	FiArrowRight,
	FiAward,
	FiTarget,
	FiZap,
	FiCheck,
	FiSearch,
	FiFilter,
	FiBookmark,
	FiCalendar,
} from 'react-icons/fi';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { RiCloseCircleFill } from 'react-icons/ri';
import { fetchAllTagsList } from '../../redux/user/userSlice';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { EventAvailable } from '@mui/icons-material';

import { fetchAllContests } from '../../redux/contest/contestSlice';
import moment from 'moment';
import LiveContest from '../../components/contestComponents/LiveContest';
import Lottie from 'react-lottie-player';
import onlinelearning from '../../assets/lottie/onlinelearning.json';
import meditation from '../../assets/lottie/meditation.json';

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 3 }}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

function a11yProps(index: number) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

const ContestDash = () => {
	const dispatch = useDispatch();

	const contestState = useSelector((state: any) => state.contest);

	const {
		allContest,
		ongoing,
		upcoming,
		past,
		missed,
		loading,
		live,
		contestName,
		startTime,
		flag,
		attemptStartTime,
		duration,
	} = contestState;

	const [ongoingContest, setOngoingContest] = useState([]);
	const [upcomingContest, setUpcomingContest] = useState([]);
	const [pastContest, setPastContest] = useState([]);
	const [liveContest, setLiveContest] = useState([]);

	const [value, setValue] = React.useState(0);

	const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};

	useEffect(() => {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		dispatch(fetchAllContests());
	}, []);
	useEffect(() => {
		if (
			upcoming.length > 0 ||
			past.length > 0 ||
			live.length > 0 ||
			ongoing.length > 0
		) {
			if (live.length > 0 || ongoing.length > 0) {
				setValue(0);
			} else if (upcoming.length > 0) {
				setValue(1);
			} else if (past.length > 0) {
				setValue(2);
			} else {
				setValue(0);
			}

			setOngoingContest(ongoing);
			setUpcomingContest(upcoming);
			setPastContest(past);
			setLiveContest(live);
		}
	}, [ongoing, upcoming, past, live]);

	const userState = useSelector((state: any) => state.user);

	const { courseList, topicTags } = userState;

	const [solved, setSolved] = useState(0);

	const [totalPageCount, setTotalPageCount] = useState(1);

	useEffect(() => {
		if (topicTags.length === 0) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			dispatch(fetchAllTagsList());
		}
	}, [topicTags]);

	const [filterTag, setFilterTags] = useState<string[]>([]);

	const handleChange = (event: SelectChangeEvent<typeof filterTag>) => {
		const {
			target: { value },
		} = event;
		setFilterTags(
			// On autofill we get a stringified value.
			typeof value === 'string' ? value.split(',') : value
		);
		console.log('TAGS', value);
	};

	console.log('tags on every render', filterTag);

	useEffect(() => {
		updateContestList();
	}, [filterTag]);

	const updateContestList = () => {
		if (filterTag.length === 0 || filterTag.includes('reset')) {
			setFilterTags([]);
			setOngoingContest(ongoing);
			setUpcomingContest(upcoming);
			setPastContest(past);
			setLiveContest(live);
		} else {
			let ongoingContestTemp = [];
			let upcomingContestTemp = [];
			let pastContestTemp = [];
			let liveContestTemp = [];

			// ongoingContestTemp = ongoing.filter((contest: any) => {
			// 	return contest.tags.some((tag: any) => filterTag.includes(tag));
			// });
			upcomingContestTemp = upcoming.filter((contest: any) => {
				return contest.tagArray.some((tag: any) =>
					filterTag.includes(tag)
				);
			});
			pastContestTemp = past.filter((contest: any) => {
				return contest.tagArray.some((tag: any) =>
					filterTag.includes(tag)
				);
			});
			liveContestTemp = live.filter((contest: any) => {
				return contest.tagArray.some((tag: any) =>
					filterTag.includes(tag)
				);
			});
			ongoingContestTemp = ongoing.filter((contest: any) => {
				return contest.tagArray.some((tag: any) =>
					filterTag.includes(tag)
				);
			});
			// ongoingContestTemp = ongoing.filter((contest: any) => {
			// 	return contest.tagArray.some((tag: any) =>
			// 		filterTag.includes(tag)
			// 	);
			// });
			// missedContestTemp = missed.filter((contest: any) => {
			// 	return contest.tagArray.some((tag: any) =>
			// 		filterTag.includes(tag)
			// 	);
			// });

			setOngoingContest(ongoingContestTemp);
			setUpcomingContest(upcomingContestTemp);
			setPastContest(pastContestTemp);
			setLiveContest(liveContestTemp);
			// setMissedContest(missedContestTemp);
		}
	};

	const tagsSearch = () => {
		if (filterTag.length > 0) {
			const filteredContest = allContest.filter((contest: any) => {
				let contestTag = false;
				contest.topicTags.forEach((tag: any) => {
					if (filterTag.includes(tag)) {
						contestTag = true;
					}
				});
				return contestTag;
			});
			setOngoingContest(filteredContest);
			setUpcomingContest([]);
			setPastContest([]);
			setLiveContest([]);
		} else {
			setOngoingContest(ongoing);
			setUpcomingContest(upcoming);
			setPastContest(past);
			setLiveContest(live);
		}
	};

	const [moduleValue, setModuleValue] = useState('Select Module');

	const filterSearch = (name: string) => {
		console.log('name', name);

		if (name === 'reset') {
			setOngoingContest(ongoing);
			setUpcomingContest(upcoming);
			setPastContest(past);
			setLiveContest(live);
			// return;
		} else {
			const upcomingTemp: [] = upcoming.filter((contest: any) => {
				return contest.courseName
					.toLowerCase()
					.includes(name.toLowerCase());
			});
			setUpcomingContest([...upcomingTemp]);
			if (ongoing !== null) {
				const ongoingTemp: [] = ongoing.filter((contest: any) => {
					return contest.courseName
						.toLowerCase()
						.includes(name.toLowerCase());
				});
				setOngoingContest([...ongoingTemp]);
			}

			const pastTemp: [] = past.filter((contest: any) => {
				return contest.courseName
					.toLowerCase()
					.includes(name.toLowerCase());
			});
			setPastContest([...pastTemp]);
		}
		const liveTemp: [] = live.filter((contest: any) => {
			return contest.courseName
				.toLowerCase()
				.includes(name.toLowerCase());
		});
		setLiveContest([...liveTemp]);
	};

	const colorDIFFMap = (diff: string): any => {
		const color = [
			{
				color: '#EF574C',
				bg: '#FDE6E4',
			},
			{
				color: '#F0B416',
				bg: 'rgba(253, 242, 214, 0.5)',
			},
			{
				color: '#12B76A',
				bg: '#E3FFED',
			},
		];
		if (diff === 'HARD') {
			return color[0];
		} else if (diff === 'MEDIUM') {
			return color[1];
		} else if (diff === 'EASY') {
			return color[2];
		}
	};

	const navigate = useNavigate();

	const navigator2 = () => {
		const path2 = '/';
		navigate(path2);
	};
	const startDate = moment(startTime).format('DD MMM YYYY');
	const style2 = {
		color: 'black',
		fontWeight: '300',
	};
	// if(ongoingContest!==null){const a = new Date(ongoingContest[0]['attemptStartTime']);
	// const b = a.getTime() + (duration * 60000);
	// const attemptEndTime = new Date(b);
	// console.log("END TIME", attemptEndTime);}
	var addMinutes = function (dt: any, minutes: any) {
		var a = new Date(dt);
		var b = a.getTime() + minutes * 60000;
		return new Date(b);
	};

	return (
		<div className="mainDiv">
			<div className={'column-1'}>
				<h1 className="contestHeading">Contests</h1>
				<Box sx={{ width: '100%' }}>
					<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
						<Tabs
							value={value}
							onChange={handleTabChange}
							aria-label="basic tabs example"
						>
							<Tab
								label="Live"
								{...a11yProps(0)}
							/>
							<Tab
								label="Upcoming"
								{...a11yProps(1)}
							/>
							<Tab
								label="Past"
								{...a11yProps(2)}
							/>
						</Tabs>
					</Box>
					<div className={'tab-panel-container'}>
						<TabPanel
							value={value}
							index={0}
						>
							{loading ? (
								<Loader />
							) : liveContest.length === 0 &&
							  ongoingContest.length === 0 ? (
								<div className={'no-contest'}>
									<div className={'animation'}>
										<div className="lottie-animation">
											<Lottie
												loop
												animationData={meditation}
												play
											/>
										</div>
									</div>
									<h3>No Live Contest Available</h3>
								</div>
							) : (
								<>
									<ul className={'contest-questions ongoing'}>
										{ongoingContest.length > 0 ? (
											ongoingContest.map(
												(el: any, index: number) => {
													return (
														<li
															key={el.contestId}
															className={
																'question'
															}
														>
															<div
																className={
																	'question-info'
																}
															>
																<div
																	className={
																		'question-details'
																	}
																>
																	<h4>
																		{
																			el.name
																		}
																	</h4>
																	<h4 className="contest-dateDisplay2">
																		SUBMIT
																		NOW!
																	</h4>
																	{
																		<h5>
																			<FiCalendar />
																			<strong>
																				Deadline:&nbsp;{' '}
																			</strong>
																			{moment(
																				addMinutes(
																					el.attemptStartTime,
																					el.duration
																				)
																			).format(
																				'LLL'
																			)}
																		</h5>
																	}
																	<ul
																		className={
																			'topic-tags'
																		}
																	>
																		{el.tagArray &&
																			el.tagArray.map(
																				(
																					tags: any
																				) => (
																					<li
																						key={
																							tags
																						}
																						className={
																							'tag'
																						}
																					>
																						{
																							tags
																						}
																					</li>
																				)
																			)}
																	</ul>
																	<ul
																		className={
																			'question-meta'
																		}
																	>
																		{/* <li>
													<FiZap />
													<span
														className={'difficulty'}
														style={{
															color: colorDIFFMap(
																el.difficulty
															).color,
															backgroundColor:
																colorDIFFMap(
																	el.difficulty
																).bg,
														}}
													>
														{el.difficulty}
													</span>
													</li>*/}
																		<li>
																			<FiTarget />{' '}
																			Max
																			Score:{' '}
																			{
																				el.maxScore
																			}{' '}
																			Points
																		</li>
																		{/* <li>
													<FiAward />
													Your Score:{' '}
													{el.user_score !== null
														? el.user_score
														: 0}{' '}
													Points
												</li> */}
																		<li>
																			{/* duration */}
																			<FiTarget />{' '}
																			Duration:{' '}
																			{
																				el.duration
																			}{' '}
																			Minutes
																		</li>
																	</ul>
																</div>
																<div
																	className={
																		'question-btn'
																	}
																>
																	{/* <span
												className={`${
													el.bookmarked
														? 'bookmarked'
														: 'bookmark'
												}`}
												onClick={() => {
													if (!el.bookmarked) {
														bookmarkThisQuestion(
															el.id
														);
													} else {
														removebookmarkFromThisQuestion(
															el.id
														);
													}
												}}
											>
												<FiBookmark />
											</span> */}
																	<button
																		className={`${
																			el.flag ===
																			'ongoing'
																				? 'ongoingContest'
																				: 'contest-question-solve-btn'
																		}`}
																		onClick={() => {
																			el.projectFlag
																				? window.open(
																						`https://course.acciojob.com/start-project?project=${el.id}`
																				  )
																				: navigate(
																						`/contest?contestId=${el.contestId}&type=ongoing`
																				  );
																			// window.location.reload();
																		}}
																	>
																		<>
																			Resume
																			Contest
																			<FiArrowRight />
																		</>
																	</button>
																</div>
															</div>
														</li>
													);
												}
											)
										) : loading ? (
											<Loader />
										) : null}
									</ul>
									<ul className={'contest-questions ongoing'}>
										{liveContest.map(
											(el: any, index: number) => {
												return (
													<li
														key={el.contestId}
														className={'question'}
													>
														<div
															className={
																'question-info'
															}
														>
															<div
																className={
																	'question-details'
																}
															>
																<h4>
																	{el.name}
																</h4>
																<h4 className="contest-dateDisplay">
																	LIVE
																</h4>
																<h5>
																	<FiCalendar />
																	<strong>
																		Ends
																		on:&nbsp;
																	</strong>
																	{moment(
																		el.endTime
																	).format(
																		'LLL'
																	)}
																	{''}
																</h5>
																<ul
																	className={
																		'topic-tags'
																	}
																>
																	{el.tagArray &&
																		el.tagArray.map(
																			(
																				tags: any
																			) => (
																				<li
																					key={
																						tags
																					}
																					className={
																						'tag'
																					}
																				>
																					{
																						tags
																					}
																				</li>
																			)
																		)}
																</ul>
																<ul
																	className={
																		'question-meta'
																	}
																>
																	{/* <li>
													<FiZap />
													<span
														className={'difficulty'}
														style={{
															color: colorDIFFMap(
																el.difficulty
															).color,
															backgroundColor:
																colorDIFFMap(
																	el.difficulty
																).bg,
														}}
													>
														{el.difficulty}
													</span>
													</li>*/}
																	<li>
																		<FiTarget />{' '}
																		Max
																		Score:{' '}
																		{
																			el.totalScore
																		}{' '}
																		Points
																	</li>
																	{/* <li>
													<FiAward />
													Your Score:{' '}
													{el.user_score !== null
														? el.user_score
														: 0}{' '}
													Points
												</li> */}
																	<li>
																		{/* duration */}
																		<FiTarget />{' '}
																		Duration:{' '}
																		{
																			el.duration
																		}{' '}
																		Minutes
																	</li>
																	{el.flag ===
																	'live-given' ? (
																		<li
																			style={
																				style2
																			}
																		>
																			<em>
																				ℹ
																				Your
																				attempt
																				has
																				already
																				been
																				recorded
																			</em>
																		</li>
																	) : null}
																</ul>
															</div>
															<div
																className={
																	'question-btn'
																}
															>
																{/* <span
												className={`${
													el.bookmarked
														? 'bookmarked'
														: 'bookmark'
												}`}
												onClick={() => {
													if (!el.bookmarked) {
														bookmarkThisQuestion(
															el.id
														);
													} else {
														removebookmarkFromThisQuestion(
															el.id
														);
													}
												}}
											>
												<FiBookmark />
											</span> */}
																<button
																	className={`${
																		el.flag ===
																		'live-given'
																			? 'contest-question-solved-btn2'
																			: 'contest-question-solve-btn'
																	}`}
																	onClick={() => {
																		el.projectFlag
																			? window.open(
																					`https://course.acciojob.com/start-project?project=${el.id}`
																			  )
																			: navigate(
																					`/contest?contestId=${el.contestId}&type=live`
																			  );
																		// window.location.reload();
																	}}
																>
																	{' '}
																	{el.flag ===
																	'live-given' ? (
																		<>
																			View
																			Contest
																		</>
																	) : (
																		<>
																			Start
																			Contest
																			<FiArrowRight />
																		</>
																	)}
																</button>
															</div>
														</div>
													</li>
												);
											}
										)}
									</ul>
								</>
							)}
						</TabPanel>
						<TabPanel
							value={value}
							index={1}
						>
							<ul className={'contest-questions upcoming'}>
								{upcomingContest.length > 0 ? (
									upcomingContest.map(
										(el: any, index: number) => {
											return (
												<li
													key={el.contestId}
													className={'question'}
												>
													<div
														className={
															'question-info'
														}
													>
														<div
															className={
																'question-details'
															}
														>
															<h4>{el.name}</h4>

															<ul
																className={
																	'topic-tags'
																}
															>
																{el.tagArray &&
																	el.tagArray.map(
																		(
																			tags: any
																		) => (
																			<li
																				key={
																					tags
																				}
																				className={
																					'tag'
																				}
																			>
																				{
																					tags
																				}
																			</li>
																		)
																	)}
															</ul>
															<ul
																className={
																	'question-meta'
																}
															>
																<li>
																	<FiCalendar />
																	{moment(
																		el.startTime
																	).format(
																		'MMM Do, hh:mm a'
																	)}{' '}
																	&nbsp; -
																	&nbsp;{' '}
																	{moment(
																		el.endTime
																	).format(
																		'MMM Do, hh:mm a'
																	)}
																</li>
																<li>
																	{/* duration */}
																	<FiTarget />{' '}
																	Duration:{' '}
																	{
																		el.duration
																	}{' '}
																	Minutes
																</li>
																{el.flag ===
																'upcoming-given' ? (
																	<li
																		style={
																			style2
																		}
																	>
																		<i>
																			ℹ
																			Your
																			attempt
																			has
																			already
																			been
																			recorded
																		</i>
																	</li>
																) : null}
															</ul>
														</div>
														<div
															className={
																'question-btn'
															}
														>
															<button
																className={`${
																	el.flag ===
																	'upcoming-given'
																		? 'contest-question-solved-btn2'
																		: 'contest-question-solve-btn'
																}`}
																onClick={() => {
																	el.projectFlag
																		? window.open(
																				`https://course.acciojob.com/start-project?project=${el.id}`
																		  )
																		: navigate(
																				`/contest?contestId=${el.contestId}&type=upcoming`
																		  );
																	// window.location.reload();
																}}
															>
																{' '}
																{el.flag ===
																'upcoming-given' ? (
																	<>
																		View
																		Contest
																	</>
																) : (
																	<>
																		View
																		Details
																		<FiArrowRight />
																	</>
																)}
															</button>
														</div>
													</div>
												</li>
											);
										}
									)
								) : loading ? (
									<Loader />
								) : (
									<div className={'no-contest'}>
										<div className={'animation'}>
											<div className="lottie-animation">
												<Lottie
													loop
													animationData={meditation}
													play
												/>
											</div>
										</div>
										<h3>No Upcoming Contest Available</h3>
									</div>
								)}
							</ul>
						</TabPanel>
						<TabPanel
							value={value}
							index={2}
						>
							<ul className={'contest-questions'}>
								{pastContest.length > 0 ? (
									pastContest.map(
										(el: any, index: number) => {
											return (
												<li
													key={el.contestId}
													className={'question'}
												>
													<div
														className={
															'question-info'
														}
													>
														<div
															className={
																'question-details'
															}
														>
															<h4>{el.name}</h4>
															<ul
																className={
																	'topic-tags'
																}
															>
																{el.tagArray &&
																	el.tagArray.map(
																		(
																			tags: any
																		) => (
																			<li
																				key={
																					tags
																				}
																				className={
																					'tag'
																				}
																			>
																				{
																					tags
																				}
																			</li>
																		)
																	)}
															</ul>
															<ul
																className={
																	'question-meta'
																}
															>
																{/* <li>
													<FiZap />
													<span
														className={'difficulty'}
														style={{
															color: colorDIFFMap(
																el.difficulty
															).color,
															backgroundColor:
																colorDIFFMap(
																	el.difficulty
																).bg,
														}}
													>
														{el.difficulty}
													</span>
												</li> */}
																<li>
																	<FiCalendar />{' '}
																	{moment(
																		el.startTime
																	).format(
																		'MMM Do'
																	)}
																	{''}
																</li>
																<li>
																	<FiTarget />{' '}
																	Max Score:{' '}
																	{
																		el.totalScore
																	}{' '}
																	Points
																</li>
																{/* <li>
													<FiAward />
													Your Score:{' '}
													{el.user_score !== null
														? el.user_score
														: 0}{' '}
													Points
												</li> */}
																<li>
																	{/* duration */}
																	<FiTarget />{' '}
																	Duration:{' '}
																	{
																		el.duration
																	}{' '}
																	Minutes
																</li>
																{el.flag ===
																'past-given' ? (
																	<li
																		style={
																			style2
																		}
																	>
																		<i>
																			ℹ
																			Your
																			attempt
																			has
																			already
																			been
																			recorded
																		</i>
																	</li>
																) : null}
															</ul>
														</div>
														<div
															className={
																'question-btn'
															}
														>
															{/* <span
												className={`${
													el.bookmarked
														? 'bookmarked'
														: 'bookmark'
												}`}
												onClick={() => {
													if (!el.bookmarked) {
														bookmarkThisQuestion(
															el.id
														);
													} else {
														removebookmarkFromThisQuestion(
															el.id
														);
													}
												}}
											>
												<FiBookmark />
											</span> */}
															<button
																className={`${
																	el.flag ===
																	'past-given'
																		? 'contest-question-solved-btn2'
																		: 'contest-question-solve-btn'
																}`}
																onClick={() => {
																	el.projectFlag
																		? window.open(
																				`https://course.acciojob.com/start-project?project=${el.id}`
																		  )
																		: navigate(
																				`/contest?contestId=${el.contestId}&type=past`
																		  );
																	// window.location.reload();
																}}
															>
																{' '}
																{el.flag ===
																'past-given' ? (
																	<>
																		View
																		Contest
																	</>
																) : (
																	<>
																		View
																		Contest
																		<FiArrowRight />
																	</>
																)}
															</button>
														</div>
													</div>
												</li>
											);
										}
									)
								) : loading ? (
									<Loader />
								) : (
									<div className={'no-contest'}>
										<div className={'animation'}>
											<div className="lottie-animation">
												<Lottie
													loop
													animationData={meditation}
													play
												/>
											</div>
										</div>
										<h3>No Past Contest Available</h3>
									</div>
								)}
							</ul>
						</TabPanel>
					</div>
				</Box>
			</div>

			<div className="column-2 rightSideCont">
				{/* <div className="leaderboardImg">
					<img
						src={leaderboardGraph}
						alt="leaderboard"
					/>
				</div> */}
				<div className="contest-filter">
					<div className={'filter-options'}>
						<div className={'filter-head'}>
							<span>
								<FiFilter />
							</span>
							<p>Filter Contests</p>
						</div>
						{/*UNDER DEVELOPMENT ----------------------- */}
						<div className={'filter-dropdown'}>
							<p>module</p>
							{courseList !== null ? (
								<Select
									value={moduleValue}
									label="Tags"
									className={
										'tag-dropdown contest-tag-filter'
									}
									onChange={(e: any) => {
										filterSearch(e.target.value);
										setModuleValue(e.target.value);
									}}
									name="Course"
								>
									<MenuItem
										key={'reset'}
										value={'reset'}
									>
										Select Module
									</MenuItem>
									{courseList.map(
										(el: any, index: number) => (
											<MenuItem
												key={el.id}
												value={el.title}
											>
												{el.title}
											</MenuItem>
										)
									)}
								</Select>
							) : null}
						</div>
						<div className={'filter-dropdown select-topic'}>
							<p>Topic</p>
							<Select
								//@ts-ignore
								value={filterTag}
								label="Tags"
								onChange={handleChange}
								multiple
								className={'tag-dropdown contest-tag-filter'}
							>
								<MenuItem
									key={'reset'}
									value={'reset'}
								>
									Select Topic
								</MenuItem>
								{topicTags.map((el: any, index: number) => (
									<MenuItem
										key={el.id}
										value={el.name}
									>
										{el.name}
									</MenuItem>
								))}
							</Select>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ContestDash;
